import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export type DialogType = 'success' | 'error' | 'warning' | 'info' | 'secret';

export interface DialogMessageData {
  title: string;
  message?: string;
  type: DialogType;

  secretValue?: string;
  copyLabel?: string;
}

@Component({
  selector: 'app-dialog-message',
  templateUrl: './dialog-message.component.html',
  styleUrls: ['./dialog-message.component.scss'],
})
export class DialogMessageComponent {
  hideSecret = true;

  constructor(
    public dialogRef: MatDialogRef<DialogMessageComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogMessageData,
  ) {}

  close() {
    this.dialogRef.close(true);
  }

  toggleSecret() {
    this.hideSecret = !this.hideSecret;
  }

  get icon(): string {
    switch (this.data.type) {
      case 'success':
        return 'check_circle';
      case 'error':
        return 'cancel';
      case 'warning':
        return 'warning';
      case 'info':
        return 'info';
      default:
        return 'info';
    }
  }

  get iconColor(): string {
    switch (this.data.type) {
      case 'success':
        return '#22c55e';
      case 'error':
        return '#ef4444';
      case 'warning':
        return '#f59e0b';
      case 'info':
        return '#3b82f6';
      default:
        return '#3b82f6';
    }
  }

  copySecret() {
    const text = this.data.secretValue ?? '';
    if (!text) return;

    navigator.clipboard?.writeText(text).then(
      () => {},
      () => {
        const ta = document.createElement('textarea');
        ta.value = text;
        ta.style.position = 'fixed';
        ta.style.left = '-9999px';
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
      },
    );
  }
}
